export const reportScheduleConstants = {
    CREATE_REQUEST: 'REPORTSCHEDULE_CREATE_REQUEST',
    CREATE_SUCCESS: 'REPORTSCHEDULE_CREATE_SUCCESS',
    CREATE_FAILURE: 'REPORTSCHEDULE_CREATE_FAILURE',

    UPDATE_REQUEST: 'REPORTSCHEDULE_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'REPORTSCHEDULE_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'REPORTSCHEDULE_UPDATE_FAILURE',

    REMOVE_REQUEST: 'REPORTSCHEDULE_REMOVE_REQUEST',
    REMOVE_SUCCESS: 'REPORTSCHEDULE_REMOVE_SUCCESS',
    REMOVE_FAILURE: 'REPORTSCHEDULE_REMOVE_FAILURE',

    FETCH_REQUEST: 'REPORTSCHEDULE_FETCH_REQUEST',
    FETCH_SUCCESS: 'REPORTSCHEDULE_FETCH_SUCCESS',
    FETCH_FAILURE: 'REPORTSCHEDULE_FETCH_FAILURE',

    GET_REQUEST: 'REPORTSCHEDULE_GET_REQUEST',
    GET_SUCCESS: 'REPORTSCHEDULE_GET_SUCCESS',
    GET_FAILURE: 'REPORTSCHEDULE_GET_FAILURE',

    RUN_REQUEST: 'REPORTSCHEDULE_RUN_REQUEST',
    RUN_SUCCESS: 'REPORTSCHEDULE_RUN_SUCCESS',
    RUN_FAILURE: 'REPORTSCHEDULE_RUN_FAILURE',
};

// Mirrors ReportSchedule.ReportKind on the backend (AgulhasNegras/Models/ReportSchedule.cs)
export const reportScheduleKindOptions = [
    { key: 0, value: 0, text: 'Uso de Licença' },
    { key: 1, value: 1, text: 'Solicitações Aprovadas (por gestor)' },
    { key: 2, value: 2, text: 'Sessões - Ativo x Bloqueado (por gestor)' },
    { key: 3, value: 3, text: 'Acessos Fora da Jornada (por gestor)' },
    { key: 4, value: 4, text: 'Usuários Sem Contato' },
];

export const MANAGER_SCOPED_KINDS = [1, 2, 3];

// Mirrors ReportSchedule.ReportFrequency
export const reportScheduleFrequencyOptions = [
    { key: 0, value: 0, text: 'Semanal' },
    { key: 1, value: 1, text: 'Mensal' },
];

export const weekDayOptions = [
    { key: 0, value: 0, text: 'Domingo' },
    { key: 1, value: 1, text: 'Segunda-feira' },
    { key: 2, value: 2, text: 'Terça-feira' },
    { key: 3, value: 3, text: 'Quarta-feira' },
    { key: 4, value: 4, text: 'Quinta-feira' },
    { key: 5, value: 5, text: 'Sexta-feira' },
    { key: 6, value: 6, text: 'Sábado' },
];
